module.exports = __webpack_public_path__ + "img/ly.d089645e.svg";